import React, { Fragment, PureComponent } from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';

import { Form, FormControl, FormActions } from '../../inputs/Form';
import Buttons from '../../buttons';
import EmailInput from '../../inputs/EmailInput';
import PasswordInput from '../../inputs/PasswordInput';
import Link from '../../buttons/Link';
import { CollectionItemHeader } from '../../typography/Content';
import { withTranslation } from 'react-i18next';

const AlternateActions = styled.div`
  flex: 1;
  & > * {
    display: block;
  }
`;

const ForgotPassword = styled(Link)`
  display: block;
  margin-bottom: ${(props) => props.theme.margins.xs};
`;

class LoginEmailForm extends PureComponent {
  static propTypes = {
    inputValue: PropTypes.string,
    onSubmit: PropTypes.func,
  };

  static defaultProps = {
    inputValue: '',
    onSubmit: () => true,
    state: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || { email: props.inputValue },
    };
  }

  handleSubmit = (values, _, __, handleServerResponse) => {
    const { onSubmit } = this.props;
    onSubmit(values, handleServerResponse);
  };

  handleBack = () => {
    this.setState({ value: { ...this.state.value, password: undefined } });
    this.props.onBack();
  };

  render() {
    const {
      autoFocus,
      hidePasswordField,
      allowDisableEmailField,
      theme,
      state,
      loading,
      token,
      t,
      onFocusEmail,
      onBack,
      onChange,
    } = this.props;
    const { value } = this.state;

    const alternateActions = (
      <AlternateActions>
        <CollectionItemHeader>{t('commonPlat:labels.newToDSG')}</CollectionItemHeader>
        <Link
          to={{
            pathname: theme.urls.routes.registerUser,
            query: { token },
            state,
          }}
        >
          {t('commonPlat:actions.createAnAccount')}
        </Link>
      </AlternateActions>
    );

    return (
      <Form value={value} onSubmit={this.handleSubmit} onChange={onChange}>
        <FormControl
          label={
            <Fragment>
              {t('commonPlat:labels.emailAddress')}{' '}
              {!hidePasswordField && allowDisableEmailField && !!onBack ? (
                <Link onClick={this.handleBack}>({t('commonPlat:actions.change')})</Link>
              ) : (
                ``
              )}
            </Fragment>
          }
        >
          <EmailInput
            id={'email'}
            required
            autoFocus={autoFocus && !value.email}
            onFocus={onFocusEmail}
            disabled={!hidePasswordField && allowDisableEmailField}
          />
        </FormControl>
        {!hidePasswordField && (
          <Fragment>
            <FormControl label={`Password`}>
              <PasswordInput id={'password'} required autoFocus={autoFocus && !!value.email} />
            </FormControl>
            <ForgotPassword to={theme.urls.routes.forgotPassword}>
              {t('commonPlat:actions.forgotPassword')}
            </ForgotPassword>
          </Fragment>
        )}
        <FormActions hideClientError alternateActions={alternateActions}>
          <Buttons.Primary disabled={loading} type={'submit'}>
            {!hidePasswordField ? t('commonPlat:actions.signIn') : t('commonPlat:actions.next')}
          </Buttons.Primary>
        </FormActions>
      </Form>
    );
  }
}

export default withTheme(withTranslation(['commonPlat'])(LoginEmailForm));
